export default function calvinCount(temp) {
  return Math.round(temp -273.15)
}
